import React from 'react';
import { Link } from 'react-router-dom';
import { GITHUB_URL, RESUME_PAGE, SITE_NAME } from '../data/site';
import '../styles/Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer-inner container">
      <span className="site-footer-name">{SITE_NAME}</span>
      <ul className="site-footer-links">
        <li>
          <a href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </li>
        <li>
          <Link to={RESUME_PAGE}>Resume</Link>
        </li>
      </ul>
      <span className="site-footer-copy">&copy; {new Date().getFullYear()}</span>
    </div>
  </footer>
);

export default Footer;
